import React, { FormEvent } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RootState } from "../../../app/store/configureStore";
import { Form, Checkbox, CheckboxProps } from "semantic-ui-react";
import { setOnlyAvailableSlotsFilter } from "../actions";
import { useAppDispatch } from "../../../app/hooks/useAppDispatch";

const OnlyAvailableSlotsFilter = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const onlyAvailableSlots: boolean | undefined = useSelector(
    (state: RootState) => state.shadowingsFilter.onlyAvailableSlots
  );

  const handleChange = (e: FormEvent<HTMLInputElement>, { checked }: CheckboxProps) => {
    checked ? dispatch(setOnlyAvailableSlotsFilter(true)) : dispatch(setOnlyAvailableSlotsFilter(undefined));
  };

  return (
    <Form>
      <Form.Field>
        <Checkbox
          onChange={handleChange}
          checked={onlyAvailableSlots}
          className="sh-filter"
          label={<label>{t("shadowings_filter.only_available_slots")}</label>}
        />
      </Form.Field>
    </Form>
  );
};

export default OnlyAvailableSlotsFilter;
